import { render, staticRenderFns } from "./ModalInsufficientBalance.vue?vue&type=template&id=21e6f6a8&"
import script from "./ModalInsufficientBalance.vue?vue&type=script&lang=js&"
export * from "./ModalInsufficientBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports